const previewAccordion = {
  init: () => {
    document.querySelectorAll('.preview-accordion').forEach(accordionEl => {
      accordionEl.querySelectorAll('.preview-accordion-desktop ul li').forEach(liEl => {
        liEl.addEventListener('mouseover', () => {
          if (liEl.classList.contains('active')) {
            return;
          }
          liEl.closest('ul').querySelectorAll('li.active').forEach(otherLiEl => otherLiEl.classList.remove('active'));
          liEl.classList.add('active');
          accordionEl.querySelectorAll('.details .detail.active').forEach(otherDetailEl => otherDetailEl.classList.remove('active'));
          accordionEl.querySelector('.details .detail.' + liEl.dataset.detail).classList.add('active');
        });
      });
    });
  }
};

document.addEventListener("DOMContentLoaded", function () {
  previewAccordion.init();
});
